var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgProviderVideoOutline = function SvgProviderVideoOutline(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#4A657B",
    strokeWidth: 1.424
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.25 20.416c0 .875-.71 1.584-1.584 1.584h-8.082C45.709 22 45 21.29 45 20.416v-6.832c0-.875.71-1.584 1.584-1.584h8.082c.875 0 1.584.71 1.584 1.584v1.44l3.072-1.638c.145-.077.318-.069.456.022s.222.252.222.425h0v7c0 .174-.084.335-.222.426-.139.09-.311.099-.457.021h0l-3.071-1.638v.774z",
    transform: "translate(-44 -11)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgProviderVideoOutline);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/provider-video-outline.ed0d8db8678e51f43794417cdca47e3a.svg";